import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box } from '@mui/material';
import { isInitialsElement } from 'utils/typeGuards';

const Initials: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isInitialsElement(currentElement)) {
    return null;
  }
  const { labelText } = currentElement.content;
  const { justifyContent } = currentElement.style;

  return (
    <Box alignItems={'center'} display={'flex'} height={'50px'} justifyContent={justifyContent} padding={'12px 16px'}>
      <span>{labelText}</span>
    </Box>
  );
};

export default Initials;
